import React, { useEffect, useState } from "react";
import "./LoaderLogo.css";

function LoaderLogo({ id, theme }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Create floating particles
    const newParticles = [];
    for (let i = 0; i < 20; i++) {
      newParticles.push({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 8,
        size: Math.random() * 3 + 2,
      });
    }
    setParticles(newParticles);
  }, []);

  return (
    <div className="loader-wrapper" id={id}>
      {/* Floating Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle"
          style={{
            left: `${p.left}%`,
            bottom: "0",
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}

      {/* Logo Box */}
      <div className="logo-box">
        <div className="logo-border"></div>
        <div className="logo-glow"></div>
        <span className="logo-text">N7</span>
      </div>

      {/* Name */}
      <div className="loader-name">AZIZOV AMINJON</div>

      {/* Loading Bar */}
      <div className="loading-bar"></div>
    </div>
  );
}

export default LoaderLogo;
